import React, { FC } from 'react'
import { EventProps } from './EventTypes'
import PreEventRow from './PreEventRow'
import LiveEventRow from './LiveEventRow'
import PostEventRow from './PostEventRow'
import SmallPostEventRow from './SmallPostEventRow'

const Events: FC<EventProps> = props => {
    if (props.type === 'PRE') return <PreEventRow {...props} />
    if (props.type === 'LIVE') return <LiveEventRow {...props} />
    if (props.type === 'POST') return <PostEventRow {...props} />
    return <SmallPostEventRow {...props} />
}

export default Events
